




















import { useGuideDriver } from '@/hooks/use-guide-driver';
import { useScrollY } from '@/hooks/use-scrolly';
import { useConfigStore } from '@/store/config';
import { getStorageMarks, updateStorageMarks } from '@/utils';
import { getMonthPeriod } from '@/utils/date-helper';
import { computed, defineComponent, onMounted, reactive, ref, toRefs, unref, watchEffect } from '@vue/composition-api';
import HeaderImage from './header-image.vue';
import headerInfoVue from './header-info.vue';
import SvgIcon from '@/components/common/svg-icon.vue';
import { windowHelper } from '@tencent/ppd-base-libs';
import { storeToRefs } from 'pinia';
import { useGrayStore } from '@/store/gray';

const getMarkHeaderStorageKey = () => `E-STAMP-HEADER-${getMonthPeriod().firstDate.toDateString()}`;

export default defineComponent({
  name: 'HeaderModule',
  props: {},
  components: {
    HeaderImage,
    headerInfoVue,
    SvgIcon,
  },

  setup() {
    const { config } = toRefs(useConfigStore());
    const { showConfig: guideDriverConfig } = useGuideDriver();
    const isShowBigHeader = ref(false);
    const scrollY = toRefs(useScrollY({ offsetPercentage: 50 }));

    const { isGrayUser } = storeToRefs(useGrayStore());
    const calcDistance = ({ percentage = 0, originalSize, targetSize, isLength = true }: {
      percentage: any, originalSize: number, targetSize: number, isLength?: boolean
    }) => {
      const division = isLength ? 200 : 1;
      return (originalSize * (1 - percentage) + targetSize * percentage) / division;
    };

    const getStyle = (num, attr, unit = 'rem') => `${attr}:${num}${unit};`;
    let headerConfig = reactive({
      leftImgUrl: '',
      rightImgSmallUrl: config.value.commonConfig.actConfig.rightImageSmallUrl,
      top: '',
      leftImgHeight: '',
      headerHeight: '',
      rightImgHeight: '',
      rightImgBigOpacity: 100,
      rightImgSmallOpacity: 0,
    });

    const colorStyle = computed(() => {
      const { bgColor } = config.value.commonConfig.actConfig || {};
      return `background-color:${bgColor};`;
    });

    const calcAllStyle = (percentage) => ({
      top: getStyle(calcDistance({ percentage, originalSize: -850, targetSize: -1010 }), 'top'),
      leftImgHeight: getStyle(calcDistance({ percentage, originalSize: 400, targetSize: 240 }), 'height'),
      headerHeight: getStyle(calcDistance({ percentage, originalSize: 400, targetSize: 240 }), 'height'),
      rightImgHeight: getStyle(calcDistance({ percentage, originalSize: 640, targetSize: 480 }), 'height'),
      rightImgBigOpacity: getStyle(calcDistance({ percentage: percentage >= 0.3 ? 1 : 0, originalSize: 1, targetSize: 0, isLength: false }), 'opacity', ''),
      rightImgSmallOpacity: getStyle(calcDistance({ percentage: 1, originalSize: 1, targetSize: 1, isLength: false }), 'opacity', ''),
    });

    const goToTnc = () => {
      const { tncLink } = config.value.commonConfig.tncModuleConfig;
      if (tncLink) {
        windowHelper.redirect(tncLink, 300);
      }
    };

    onMounted(() => {
      const marks = getStorageMarks(getMarkHeaderStorageKey());
      console.log('===marks', getMarkHeaderStorageKey(), marks);
      if (marks.length !== 0) {
        isShowBigHeader.value = false;
        headerConfig = Object.assign(headerConfig, calcAllStyle(1));
        console.log('====headerConfig', headerConfig);
      }
    });

    watchEffect(() => {
      // fix: 新手引导页面滚动导致这里缩放的影响，新手引导展示时不响应高度变化
      const { isShow } = guideDriverConfig;
      if (isShow) {
        return;
      }
      let updatePercent ;
      if (isShowBigHeader.value) {
        updatePercent = scrollY.percentage.value;
        if (unref(scrollY.percentage.value) >= 1) {
          // 如果偏移量已经超过了100%，那么不再展示大图
          isShowBigHeader.value = false;
          // 更新storage:下次进入直接打开小图
          updateStorageMarks(getMarkHeaderStorageKey(), ['1']);
        }
      } else {
        // 如果不展示大图，那么用100%(小图)
        updatePercent = 1;
      }
      headerConfig = Object.assign(headerConfig, calcAllStyle(updatePercent));
    });

    return {
      colorStyle,
      headerConfig,
      isShowBigHeader,
      goToTnc,
      isGrayUser,
    };
  },
});
